import BonusIndicator from 'modules/bonus-indicator/index.js';
import BonusIndicatorTypes from 'modules/bonus-indicator/types.js';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

const { selectAllowEarlyPayout } = MojitoServices.UserInfo.selectors;
const { Image } = MojitoPresentation.Components;

export default function MarketSignpostingIcons(props) {
    const { earlyPayout, hasCashout, hasMatchAcca, mojitoTools } = props;
    const { config } = mojitoTools;

    const allowEarlyPayout = useSelector(selectAllowEarlyPayout);
    const shouldShowEarlyPayout =
        !!earlyPayout?.rules && allowEarlyPayout && config.showEarlyPayoutIndicator;
    const shouldShowCashout = hasCashout && config.showCashoutIcon;
    const shouldShowMatchAcca = hasMatchAcca && config.showMatchAccaIcon;
    const bonusInfo = useMemo(() => ({ rules: earlyPayout?.rules }), [earlyPayout?.rules]);

    if (!shouldShowEarlyPayout && !shouldShowCashout && !shouldShowMatchAcca) {
        return null;
    }

    return (
        <>
            {shouldShowEarlyPayout && (
                <BonusIndicator
                    class="ta-earlyPayoutIndicator"
                    config={config.earlyPayoutIndicator}
                    bonusType={BonusIndicatorTypes.TYPES.EARLY_PAYOUT}
                    bonusInfo={bonusInfo}
                />
            )}
            {shouldShowCashout && <Image config={config.cashoutIcon} class="ta-cashoutIcon" />}
            {shouldShowMatchAcca && (
                <Image config={config.matchAccaIcon} class="ta-matchAccaIcon" />
            )}
        </>
    );
}
